import "react-alice-carousel/lib/alice-carousel.css";

import {
    AspectRatio,
    Box,
    Flex,
    Grid,
    GridItem,
    Heading,
    HStack,
    Icon,
    Image,
    Link,
    Stack,
    Text,
    useBreakpointValue,
    VStack,
} from "@chakra-ui/react";
import { TriangleIcon } from "@phosphor-icons/react/dist/ssr";
import { omit } from "lodash";
import { useEffect, useRef, useState } from "react";

import FiltersContext from "@/context/filtersContext";
import { useGetPropertiesQuery } from "@/hooks/microservicesApi";
import useQuery from "@/hooks/useQuery";
import ListadoCard from "@/sections/busqueda/CardList";
import Mapa from "@/sections/busqueda/Map";
import MenuFiltros from "@/sections/busqueda/Menu";
import MenuFiltrosMobile from "@/sections/busqueda/MenuMobile";
import Container from "@/sections/general/Container";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";
import styles from "@/styles/LandingGuiaRent.module.css";

export default function GuiaRent(props) {
    const [poster, showPoster] = useState(true);
    const videoEl = useRef(null);

    const playVideo = () => {
        videoEl.current.play();
        showPoster(false);
    };

    const video = [
        {
            videoUrl:
                "https://media.grupoguia.mx/assets/guiarentInquilino/video/guiarent_inquilino.mp4",
        },
    ];

    const img = [
        { imgUrl: "https://media.grupoguia.mx/assets/guiarentInquilino/one.webp" },
        { imgUrl: "https://media.grupoguia.mx/assets/guiarentInquilino/two.webp" },
        { imgUrl: "https://media.grupoguia.mx/assets/guiarentInquilino/three.webp" },
        { imgUrl: "https://media.grupoguia.mx/assets/guiarentInquilino/four.webp" },
        { imgUrl: "https://media.grupoguia.mx/assets/guiarentInquilino/five.webp" },
    ];

    const DATA = [
        {
            text: "Investigación sin costo.",
            img: img[0].imgUrl,
        },
        {
            text: "Precalifica para rentar un inmueble en menos de 24 horas.",
            img: img[1].imgUrl,
        },
        {
            text: "Renta sin necesidad de un aval.",
            img: img[2].imgUrl,
        },
        {
            text: "Genera historial crediticio.",
            img: img[3].imgUrl,
        },
        {
            text: "Recupera tu depósito.",
            img: img[4].imgUrl,
        },
    ];

    const redirectTab = () => {
        window.open(
            "https://media.grupoguia.mx/assets/guiarentLanding/pdf/Brochure_inquilino.pdf",
            "_blank"
        );
        window.location.href = "https://grupoguia.mx/guiarent-propietario-brochure-gracias";
    };

    const { queryParams } = useQuery();
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const isGreaterThanLg = useBreakpointValue({ base: false, lg: true });
    const isResultDevs = false;
    const [view, setView] = useState("list");
    const [params, setParams] = useState(queryParams);
    const [buttonFloat, setButtonFloat] = useState(true);

    const params_omit = omit(params, [
        "all",
        "page",
        "operation",
        "type",
        "location",
        "ground",
        "price",
        "parking",
    ]);

    const body_search = {
        ...params_omit,
        operation: params.operation ? params.operation.split(",") : [],
        type:
            params.type === "HABITATIONAL"
                ? ["HOUSE", "APARTMENT"]
                : params.type === "HOUSE"
                  ? ["HOUSE"]
                  : params.type === "APARTMENT"
                    ? ["APARTMENT"]
                    : [],
        price: params.price ? params.price.split(",").map(Number) : [],
        groundSize: params.groundSize ? params.groundSize.split(",").map(Number) : [],
        bedrooms: params.bedrooms ? [Number(params.bedrooms)] : [],
        bathrooms: params.bathrooms ? [Number(params.bathrooms)] : [],
        halfBathrooms: params.halfBathrooms ? [Number(params.halfBathrooms)] : [],
        pakingLots: params.parking ? [Number(params.parking)] : [],
        radius: 5000,
        labels: ["GUIARENT"],
    };

    const { data, error, isLoading, isFetching, isSuccess } = useGetPropertiesQuery({
        body: body_search,
    });

    const [screenSize, getDimension] = useState({
        winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
        winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    });

    const setDimensions = () => {
        getDimension({
            winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
            winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimensions);

        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [screenSize]);

    useEffect(() => {
        setParams(queryParams);
    }, [queryParams]);

    return (
        <>
            <Header />
            <Box px={{ md: 16, base: 4 }} pt={{ base: "10px", md: 0 }}>
                <Flex
                    pt={{ base: "30px", md: 0 }}
                    mt={{ base: "60px" }}
                    h={{ md: "60vh", base: "100%" }}
                    position="relative"
                    alignItems="center"
                    justifyContent="center"
                >
                    {poster === true && (
                        <Stack
                            onClick={playVideo}
                            cursor="pointer"
                            w="full"
                            h="full"
                            mx="auto"
                            position="absolute"
                            left="0"
                            right="0"
                            top="0"
                            bottom="0"
                            rounded="xl"
                            overflow="hidden"
                        >
                            <VStack
                                w="full"
                                position="relative"
                                zIndex="20"
                                h="full"
                                justifyContent="center"
                                alignItems="center"
                                mt="auto"
                                mx="auto"
                            >
                                <Icon
                                    className={styles.icon}
                                    fontSize={{ md: "6xl", base: 32 }}
                                    textAlign="center"
                                    color="white"
                                    my="auto"
                                >
                                    <TriangleIcon weight="fill" />
                                </Icon>

                                <Heading
                                    as="h1"
                                    color="white"
                                    marginTop="12"
                                    fontWeight="700"
                                    fontSize={{ md: "4xl", base: 14 }}
                                >
                                    Rentar la propiedad de tus sueños sin aval
                                </Heading>
                                <Heading
                                    as="h2"
                                    color="white"
                                    style={{ margin: 0 }}
                                    fontWeight="400"
                                    fontSize={{ md: "3xl", base: 14 }}
                                    pb={{ md: "8", base: 2 }}
                                >
                                    nunca había sido tan fácil
                                </Heading>
                                <br></br>
                            </VStack>
                            <Box
                                h={{ md: "60vh", base: "100%" }}
                                className={styles.backgroundVideoInquilino}
                                zIndex="10"
                            />
                        </Stack>
                    )}
                    <AspectRatio ratio={16 / 8} h="full" w="full">
                        <video ref={videoEl} src={video[0].videoUrl} w="100%">
                            Tu navegador no admite el elemento <code>video</code>.
                        </video>
                    </AspectRatio>

                    <HStack
                        zIndex="30"
                        position="absolute"
                        bottom={{ md: "-8", base: "-16" }}
                        left="0"
                        right="0"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Link
                            color="accent.500"
                            bg="brand.500"
                            px="14"
                            py="3"
                            rounded="full"
                            fontWeight={600}
                            m="2"
                            onClick={() => redirectTab()}
                        >
                            Descarga brochure
                        </Link>
                    </HStack>
                </Flex>
                <Container
                    maxW={{ base: "md", md: "6xl" }}
                    paddingTop={{ base: "50px", md: "100px" }}
                    paddingBottom={{ base: "50px", md: "40px" }}
                    display={{ base: "none", md: "block" }}
                >
                    <Grid templateColumns="repeat(5, 1fr)" gap={2} alignItems="center" mt="4">
                        {DATA?.map((item, index) => (
                            <GridItem colSpan={{ md: 1, base: 2 }} key={`image-grid-item-${index}`}>
                                <Box
                                    px="2"
                                    shadow="lg"
                                    rounded="xl"
                                    maxW="250px"
                                    height="180px"
                                    key={`card_${index}`}
                                >
                                    <VStack height="100%" justifyContent="center">
                                        <HStack>
                                            <Image src={item.img} w="22" alt="simple icon" />
                                        </HStack>
                                        <Text
                                            textAlign="center"
                                            fontSize={{ base: "xs", lg: "sm" }}
                                        >
                                            {item.text}
                                        </Text>
                                    </VStack>
                                </Box>
                            </GridItem>
                        ))}
                    </Grid>
                </Container>
            </Box>
            <Container maxW="8xl" {...(screenSize.winWidth <= 768 && { paddingInline: "0" })}>
                <Flex position="relative">
                    <Box
                        mt={4}
                        {...props}
                        paddingInline="0"
                        position={isGreaterThanLg || isGreaterThanMd ? "relative" : "absolute"}
                    >
                        {/* Area para los filtros, parece que en mapa debe tener menor altura */}
                        <Stack position="sticky" top={0} style={{ position: "-webkit-sticky" }}>
                            <Flex
                                direction="row"
                                justify="center"
                                bottom="0"
                                w="auto"
                                pl={screenSize.winWidth > 767 ? 20 : 2}
                                left="0"
                                right="0"
                            >
                                <FiltersContext data={data}>
                                    {screenSize.winWidth > 767 ? (
                                        <MenuFiltros
                                            params={queryParams}
                                            isCDMX={false}
                                            view={view}
                                            setView={setView}
                                            city="guiarent"
                                        />
                                    ) : (
                                        <Stack mt={20}>
                                            <MenuFiltrosMobile
                                                params={queryParams}
                                                view={view}
                                                setView={setView}
                                                city="guiarent"
                                            />
                                        </Stack>
                                    )}
                                </FiltersContext>
                            </Flex>
                        </Stack>
                    </Box>
                    {/* Area de trabajo, muestra la lista o el mapa */}
                    <Box
                        position={buttonFloat ? null : "relative"}
                        width={isGreaterThanLg ? "100%" : isGreaterThanMd ? "60%" : "90%"}
                        mt={isGreaterThanLg ? "4rem" : "9rem"}
                        paddingBottom="100px"
                    >
                        {view === "list" ? (
                            <Container
                                maxW={{ base: "100%", md: isGreaterThanMd ? "2xl" : "3xl" }}
                                m="auto"
                            >
                                <Flex
                                    pl={isGreaterThanLg ? 0 : isGreaterThanMd ? 10 : 10}
                                    m="auto"
                                    justifyContent={
                                        isGreaterThanLg || isGreaterThanMd ? "start" : "center"
                                    }
                                >
                                    <Box
                                        w={
                                            isGreaterThanLg
                                                ? "100%"
                                                : isGreaterThanMd
                                                  ? "80%"
                                                  : "90%"
                                        }
                                        mb="5"
                                    >
                                        <ListadoCard
                                            isResultDevs={isResultDevs}
                                            data={data}
                                            error={error}
                                            isLoading={isLoading}
                                            isFetching={isFetching}
                                            isSuccess={isSuccess}
                                            setButtonFloat={setButtonFloat}
                                            params={params}
                                            isCDMX={false}
                                            isPropertyTypePage={false}
                                        />
                                    </Box>
                                </Flex>
                            </Container>
                        ) : (
                            <Flex justifyContent="end" pt="2" maxW={{ base: "90%", md: "100%" }}>
                                <Box w="100%" h="84vh" bg="#999" ml={10}>
                                    <Mapa data={data} params={params} />
                                </Box>
                            </Flex>
                        )}
                    </Box>
                </Flex>
            </Container>
            <Footer />
        </>
    );
}
